/* "In this article" table of contents (sections/main-article.liquid).
   Builds anchor links from the article body's H2s and highlights the one
   currently in view. The whole TOC stays hidden when there are fewer than
   two headings. */
(function () {
  'use strict';

  function init() {
    var wrap = document.querySelector('[data-toc-wrap]');
    var toc = document.querySelector('[data-toc]');
    var content = document.querySelector('[data-article-content]');
    if (!wrap || !toc || !content) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (headings.length < 2) return;

    var links = [];
    headings.forEach(function (heading, index) {
      if (!heading.id) {
        var slug = heading.textContent
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .replace(/\s+/g, '-')
          .slice(0, 60);
        heading.id = slug || 'section-' + (index + 1);
      }
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      toc.appendChild(link);
      links.push(link);
    });

    wrap.hidden = false;

    if ('IntersectionObserver' in window) {
      var setActive = function (id) {
        links.forEach(function (link) {
          link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
        });
      };
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActive(entry.target.id);
          });
        },
        { rootMargin: '-20% 0px -70% 0px' }
      );
      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
